<template>
  <card-modal :visible="true" :title="title" :showPreview="false" :okText="'Submeter'" :disableOk="false">
    <div id="modal-edit-content" class="content subslide-model">
      
      <p class="control">
        <span class="select">
          <select v-model="editLanguage">
            <option v-for="language of languageList" 
                    :value="language.slug"
            >{{language.name}}</option>
          </select>
        </span>
      </p>

      <div v-for="language of languageList"
           v-show="language.slug === editLanguage"
           class="localization columns"
      >
        <div class="column is-half">
          <p class="control">
            <label class="label">{{'Texto do Botão ['+ language.name +']'}}</label>
            <input class="input is-expanded" type="text" v-model="category.local[language.slug].button">
          </p>
        </div>
        <div class="column is-half">
          <p class="control">
            <label class="label">{{'Título do Grupo ['+ language.name +']'}}</label>
            <input class="input is-expanded" type="text" v-model="category.local[language.slug].title">
          </p>
        </div>
      </div>

      <div class="columns">
        <div class="column is-half">
          <label class="label">Cor de Fundo</label>
          <p class="control has-addons">
            <input class="input is-expanded" type="text" placeholder="Código de Cor (#HEX)" v-model="category.background_color.hex" disabled>
            <a class="button is-primary"
               :class="[colorPickerBtnTextBackground === 'Fechar' ? 'is-outlined' : '']"
               @click="toogleColorPicker('background')"
            >{{ colorPickerBtnTextBackground }}</a>
          </p>
        </div>
        <div class="column is-half">
          <input class="input category-color-preview" type="text" v-bind:style="{ backgroundColor: category.background_color.hex }" disabled>
        </div>
      </div>  
      <div class="columns">
        <div class="column is-half">
          <label class="label">Cor Caixa de Texto</label>
          <p class="control has-addons">
            <input class="input is-expanded" type="text" placeholder="Código de Cor (#HEX)" v-model="category.textbox_color.hex" disabled>
            <a class="button is-primary"
               :class="[colorPickerBtnTextTextbox === 'Fechar' ? 'is-outlined' : '']"
               @click="toogleColorPicker('textbox')"
            >{{ colorPickerBtnTextTextbox }}</a>
          </p>
        </div>
        <div class="column is-half">
          <input class="input category-color-preview" type="text" v-bind:style="{ backgroundColor: category.textbox_color.hex }" disabled>
        </div>
      </div>  
      <div class="columns">
        <div class="column is-half">
          <label class="label">Cor do Texto</label>
          <p class="control has-addons">
            <input class="input is-expanded" type="text" placeholder="Código de Cor (#HEX)" v-model="category.text_color.hex" disabled>
            <a class="button is-primary"
               :class="[colorPickerBtnTextText === 'Fechar' ? 'is-outlined' : '']"
               @click="toogleColorPicker('text')"
            >{{ colorPickerBtnTextText }}</a>
          </p>
        </div>
        <div class="column is-half">
          <input class="input category-color-preview" type="text" v-bind:style="{ backgroundColor: category.text_color.hex }" disabled>
        </div>
      </div>

      <sketch-picker v-show="showColorPicker" 
                     v-model="pickerColor"
                     @input="onChangePickerColor"
                     :class="'color-picker-position-' + colorPickerPosition"
      ></sketch-picker>

      <div class="columns">
        <div class="column is-12">
          <label class="label">Background 1 <span class="font-weight-light">(*x1008px)</span></label>
          <figure v-if="!newBackground1 && category.background_image_1" 
                  class="image coach-image background-1 fake-dropzone"
          >
            <img :src="category.background_image_1">
            <a class="dz-remove" @click="showDropzone('background1')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="categoryBackground1"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl"
                      v-bind:thumbnail-width="596"
                      v-bind:thumbnail-height="150"
                      v-on:vdropzone-success="successUploadBackground"
                      v-on:vdropzone-removedfile="removeBackground"
                      acceptedFileTypes="image/*"
            ></dropzone>
          </p>
        </div>
      </div>

       <div class="columns">
        <div class="column is-12">
          <label class="label">Background 2 <span class="font-weight-light">(*x1008px)</span></label>
          <figure v-if="!newBackground2 && category.background_image_2" 
                  class="image coach-image background-2 fake-dropzone"
          >
            <img :src="category.background_image_2">
            <a class="dz-remove" @click="showDropzone('background2')">Remover</a>
          </figure>
          <p v-else class="control">
            <dropzone id="categoryBackground2"
                      class="marginless-dropzone dz-dom"
                      :url="dropzoneUploadUrl"
                      v-bind:thumbnail-width="596"
                      v-bind:thumbnail-height="150"
                      v-on:vdropzone-success="successUploadForeground"
                      v-on:vdropzone-removedfile="removeForeground"
                      acceptedFileTypes="image/*"
            ></dropzone>
          </p>
        </div>
      </div>
    </div>

  </card-modal>
</template>

<script>
import CardModal from '../Util/CardModal'
import Sketch from '../Util/Picker/ColorPicker'
import { WHITE_COLOR, API_ROOT, BACKGROUND_IMG_PATH, LANGUAGE_LIST } from '../../config'
import Dropzone from '../Util/DropzoneForm'
import tinycolor from 'tinycolor2'

function setColor (data, oldHue) {
  var color = data.hex ? tinycolor(data.hex) : tinycolor(data)
  var hsl = color.toHsl()
  var hsv = color.toHsv()
  if (hsl.s === 0) {
    hsl.h = data.h || oldHue || 0
    hsv.h = data.h || oldHue || 0
  }
  return {
    hsl: hsl,
    hex: color.toHexString().toUpperCase(),
    rgba: color.toRgb(),
    hsv: hsv,
    a: 1
  }
}

/* global Image */
function getImgSize (imgSrc, callback) {
  let newImg = new Image()
  newImg.onload = function () {
    if (callback !== undefined) {
      callback({width: newImg.width, height: newImg.height})
    }
  }
  newImg.src = imgSrc
}

export default {
  components: {
    CardModal,
    'sketch-picker': Sketch,
    Dropzone
  },

  props: {
    title: String,
    coach_id: Number,
    menu_id: Number,
    parent_slide_id: Number,
    categoryData: Object
  },

  data () {
    return {
      languageList: LANGUAGE_LIST,
      editLanguage: 'pt',
      pickerColor: WHITE_COLOR,
      showColorPicker: false,
      currentColorPicker: 'background',
      colorPickerPosition: 1,
      colorPickerBtnTextBackground: 'Selecionar Cor',
      colorPickerBtnTextTextbox: 'Selecionar Cor',
      colorPickerBtnTextText: 'Selecionar Cor',
      showPreview: false,
      category: {
        background_color: WHITE_COLOR,
        textbox_color: WHITE_COLOR,
        text_color: WHITE_COLOR,
        background_image_1: null,
        background_image_2: null,
        background_path_1: null,
        background_path_2: null,
        local: {
          pt: {
            button: null,
            title: null
          },
          en: {
            button: null,
            title: null
          },
          es: {
            button: null,
            title: null
          },
          fr: {
            button: null,
            title: null
          }
        }
      },
      newBackground1: false,
      newBackground2: false
    }
  },

  beforeDestroy () {
    let trash = document.body.querySelectorAll('.dz-hidden-input')
    for (let t of trash) {
      t.remove()
    }
  },

  mounted () {
    if (this.categoryData) {
      this.category.local.pt.button = this.categoryData.parent_languages[0].pivot.popup_button
      this.category.local.en.button = this.categoryData.parent_languages[1].pivot.popup_button
      this.category.local.es.button = this.categoryData.parent_languages[2].pivot.popup_button
      this.category.local.fr.button = this.categoryData.parent_languages[3].pivot.popup_button

      this.category.local.pt.title = this.categoryData.languages[0].pivot.name ? this.categoryData.languages[0].pivot.name : null
      this.category.local.en.title = this.categoryData.languages[1].pivot.name ? this.categoryData.languages[1].pivot.name : null
      this.category.local.es.title = this.categoryData.languages[2].pivot.name ? this.categoryData.languages[2].pivot.name : null
      this.category.local.fr.title = this.categoryData.languages[3].pivot.name ? this.categoryData.languages[3].pivot.name : null

      this.category.background_color = setColor(this.categoryData.background_color)
      this.category.textbox_color = setColor(this.categoryData.textbox_color)
      this.category.text_color = setColor(this.categoryData.text_color)

      this.category.background_image_1 = this.categoryData.background_path_1 ? BACKGROUND_IMG_PATH + this.categoryData.background_path_1 : null
      this.category.background_path_1 = this.categoryData.background_path_1
      this.category.background_image_2 = this.categoryData.background_path_2 ? BACKGROUND_IMG_PATH + this.categoryData.background_path_2 : null
      this.category.background_path_2 = this.categoryData.background_path_2
    }

    let _this = this
    if (_this.category.background_image_1) {
      getImgSize(_this.category.background_image_1, function (imgSize) {
        if (imgSize.width > 6458) {
          let resize = (imgSize.width * 100) / 1080
          document.querySelector('.background-1 img').style.minWidth = resize + 'px'
        }
      })
    }

    if (_this.category.background_image_2) {
      getImgSize(_this.category.background_image_2, function (imgSize) {
        if (imgSize.width > 6458) {
          let resize = (imgSize.width * 100) / 1080
          document.querySelector('.background-2 img').style.minWidth = resize + 'px'
        }
      })
    }
  },

  computed: {
    currentEvent () {
      return window.store.state.event.nextEvent
    },

    userToken () {
      return window.store.state.auth.token
    },

    dropzoneUploadUrl () {
      return API_ROOT + 'resource/subslide/upload/background?token=' + this.userToken
    }
  },

  methods: {
    successUploadBackground (file) {
      let path = JSON.parse(file.xhr.response).file
      this.category.background_image_1 = path ? BACKGROUND_IMG_PATH + JSON.parse(file.xhr.response).file : null
      this.category.background_path_1 = JSON.parse(file.xhr.response).file

      this.newBackground1 = false

      let _this = this
      getImgSize(_this.category.background_image_1, function (imgSize) {
        if (imgSize.width > 6458) {
          let resize = (imgSize.width * 100) / 1080
          document.querySelector('.background-1 img').style.minWidth = resize + 'px'
        }
      })
    },

    removeBackground () {
      console.log('A file was been removed')
      this.category.background_image_1 = null
      this.category.background_path_1 = null
    },

    successUploadForeground (file) {
      let path = JSON.parse(file.xhr.response).file
      this.category.background_image_2 = path ? BACKGROUND_IMG_PATH + JSON.parse(file.xhr.response).file : null
      this.category.background_path_2 = JSON.parse(file.xhr.response).file

      this.newBackground2 = false

      let _this = this
      getImgSize(_this.category.background_image_2, function (imgSize) {
        if (imgSize.width > 6458) {
          let resize = (imgSize.width * 100) / 1080
          document.querySelector('.background-2 img').style.minWidth = resize + 'px'
        }
      })
    },

    removeForeground () {
      console.log('A file was been removed')
      this.category.background_image_2 = null
      this.category.background_path_2 = null
    },

    onChangePickerColor (val) {
      switch (this.currentColorPicker) {
        case 'background':
          this.category.background_color = val
          break
        case 'textbox':
          this.category.textbox_color = val
          break
        case 'text':
          this.category.text_color = val
          break
      }
    },

    toogleColorPicker (selector) {
      if (selector === this.currentColorPicker || !this.showColorPicker) {
        this.showColorPicker = !this.showColorPicker
      }
      this.currentColorPicker = selector

      this.colorPickerBtnTextBackground = 'Selecionar Cor'
      this.colorPickerBtnTextTextbox = 'Selecionar Cor'
      this.colorPickerBtnTextText = 'Selecionar Cor'

      switch (selector) {
        case 'background':
          if (this.showColorPicker) {
            this.pickerColor = this.category.background_color
            this.colorPickerBtnTextBackground = 'Fechar'
          }
          this.colorPickerPosition = 1
          break
        case 'textbox':
          if (this.showColorPicker) {
            this.pickerColor = this.category.textbox_color
            this.colorPickerBtnTextTextbox = 'Fechar'
          }
          this.colorPickerPosition = 2
          break
        case 'text':
          if (this.showColorPicker) {
            this.pickerColor = this.category.text_color
            this.colorPickerBtnTextText = 'Fechar'
          }
          this.colorPickerPosition = 3
          break
        default:
          this.showColorPicker = false
      }
    },

    showDropzone (selector) {
      if (selector === 'background1') {
        this.newBackground1 = true
        this.removeBackground()
      }

      if (selector === 'background2') {
        this.newBackground2 = true
        this.removeForeground()
      }
    }
  },

  watch: {
    currentEvent: function (val) {
      if (val === 'modal-card-close') {
        this.$destroy()
      }
      if (val === 'modal-card-ok') {
        if (this.categoryData) {
          let data = {
            coach: this.coach_id,
            menu: this.menu_id,
            parent: null,
            category: this.category
          }
          window.store.dispatch('updateSubSlideCategory', data)
        } else {
          let data = {
            coach: this.coach_id,
            menu: this.menu_id,
            parent: this.parent_slide_id,
            category: this.category
          }
          window.store.dispatch('setSubSlideCategory', data)
        }
      }
      if (val === 'modal-card-preview') {
        // no preview
      }
      if (val === 'modal-card-cancel') {
        window.store.dispatch('newEvent', 'modal-card-close')
      }
    }
  }
}
</script>

<style>
  @import url('~dropzone/dist/dropzone.css');
  @import 'https://fonts.googleapis.com/css?family=Roboto';

  .is-hidden {
    display: none !important;
  }

  .vue-color__sketch {
    position: absolute !important;
    top: 73px;
    right: 100px;
    z-index: 100;
  }

  .vue-color__sketch__hue-wrap {
    height: 24px !important;
  }

  .vue-color__c-hue__picker {
    height: 22px !important;
  }

  @media screen and (min-width: 769px) {
    .category-color-preview {
      margin-top: 25px;
    }
  }

  .subslide-model .color-picker-position-1 {
    top: 134px !important;
  }

  .subslide-model .color-picker-position-2 {
    top: 210px !important;
  }

  .subslide-model .color-picker-position-3 {
    top: 287px !important;
  }

  #categoryBackground1,
  #categoryBackground2 {
    height: 146px;
    display: flex;
  }

  #categoryBackground1.dropzone .dz-preview .dz-error-message,
  #categoryBackground2.dropzone .dz-preview .dz-error-message {
    top: 90px;
    left: 228px;
  }

  #categoryBackground1.dropzone .dz-message,
  #categoryBackground2.dropzone .dz-message {
    margin: 3.4em auto;
  }

  .content #categoryBackground1 a:not(.button):hover,
  .content #categoryBackground2 a:not(.button):hover {
    border-bottom-color: inherit;
  }

  .fake-dropzone .dz-remove {
    font-family: 'Roboto', sans-serif;
    color: #777;
    position: absolute;
    z-index: 30;
    color: white;
    margin-left: 15px;
    padding: 10px;
    top: inherit;
    bottom: 15px;
    border: 2px white solid;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 1.1px;
    opacity: 0;
    text-align: center;
    display: block;
    cursor: pointer;
    background-color: rgba(37, 148, 139, 0.8);
  }

  .fake-dropzone:hover .dz-remove {
    opacity: 1;
  }

  .fake-dropzone a:not(.button) {
    border-bottom: 2px white solid !important;
  }

  .fake-dropzone a:not(.button):hover, .content #categoryBackground2 a:not(.button):hover {
    border-bottom-color: inherit !important;
  }

  .background-1,
  .background-2 {
    overflow-x: auto;
  }

  .background-1 img,
  .background-2 img {
    min-height: 100px;
  }
</style>


// WEBPACK FOOTER //
// SlideSetEditModal.vue?3f640ffa